import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetCheques = async (params: {
  page: number;
  limit: number;
  search?: string;
  status_id?: string | null;
  type?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/cheques`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load cheques.",
      data: { data: [], total: 0 },
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateCheque = async (payload: {
  type: "in" | "out";
  cheque_no: string;
  amount: number;
  bank_name: string;
  bank_branch?: string;
  cheque_date: string;
  payee?: string;
  store_id?: string;
  bank_account_id?: string;
  note?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cheques/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create cheque.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateCheque = async (payload: {
  id: string;
  cheque_no: string;
  amount: number;
  bank_name: string;
  bank_branch?: string;
  cheque_date: string;
  payee?: string;
  bank_account_id?: string;
  note?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cheques/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update cheque.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteCheque = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cheques/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete cheque.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateChequeStatus = async (payload: {
  id: string;
  status_id: string;
  bank_account_id?: string | null;
  realized_date?: string | null;
  status_note?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/cheques/status`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update cheque status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
